import AuthSnackbar from '@/components/common/auth/AuthSnackbar';
import { MetadataProvider } from '@/context/MetadataProvider';
import useDebouncedLocalStorage from '@/hooks/useDebouncedLocalStorage';
import { Application } from '@/types/application';
import { Box, useTheme } from '@mui/system';
import { useState, type FC } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import ApplicationPickersContainer from './applicationPicker/ApplicationPickersContainer';
import ComparerAppBar from './ComparerAppBar';
import ComparerResults from './comparerResults/ComparerResultsContainer';

export type Side = 'A' | 'B';

const BlockEngineComparer: FC = () => {
  const theme = useTheme();

  const [appA, setAppA] = useDebouncedLocalStorage<Application | undefined>('ComparerIdA', undefined);
  const [appB, setAppB] = useDebouncedLocalStorage<Application | undefined>('ComparerIdB', undefined);
  const [labelA, setLabelA] = useLocalStorage('ComparerLabelA', '');
  const [labelB, setLabelB] = useLocalStorage('ComparerLabelB', '');
  const [viewResults, setViewResults] = useState<boolean>(false);

  return (
    <MetadataProvider>
      <Box
        sx={{
          color: theme.palette.text.primary,
          bgcolor: theme.palette.background.paper,
          height: '100%'
        }}
      >
        <ComparerAppBar viewResults={viewResults} setViewResults={(value) => setViewResults(value)} />
        {viewResults && appA && appB ? (
          <ComparerResults savedAppA={appA} savedAppB={appB} savedLabelA={labelA} savedLabelB={labelB} />
        ) : (
          <ApplicationPickersContainer
            appA={appA}
            appB={appB}
            labelA={labelA}
            labelB={labelB}
            setAppA={(newApp) => setAppA(newApp)}
            setAppB={(newApp) => setAppB(newApp)}
            setLabelA={(newLabel) => setLabelA(newLabel)}
            setLabelB={(newLabel) => setLabelB(newLabel)}
            viewResults={(value) => setViewResults(value)}
          />
        )}
        <AuthSnackbar message='You are not logged in' position={{ vertical: 'top', horizontal: 'center' }} />
      </Box>
    </MetadataProvider>
  );
};

export default BlockEngineComparer;
